import { systemName } from '@/config';

/**
 * 设置title
 * @param {String} title title
 * @return {String} title
 */
export default function getPageTitle(title) {
  if (title) {
    return `${title} - ${systemName}`;
  }
  return `${systemName}`;
}